$(function(){
	let prevLoadFilter = '';
	$('.filter-select-box').on('click',function(){
		$(this).removeClass('kte-popop-show');
	}).on('click','.content',function(event){
		event.stopPropagation();
	}).on('click','.close-btn',function(){
		$('.kte-popop-show').removeClass('kte-popop-show');
	})

	$('.cate-filter-area').on('click','.filter-item',function(){
		const url = $(this).attr('data-url');
		const queryParam = kte.getURLvar();
		delete queryParam.route;
		if(url === prevLoadFilter){
			$('.filter-select-box').addClass('kte-popop-show');
			return;
		}
		prevLoadFilter = url;
		kte.globalLoading();
		$('.filter-select-box').html('').load(url,{...queryParam},function(){
			kte.globalLoading();
			$('.filter-select-box').addClass('kte-popop-show');
		});
	})
})